import ConditionBox from '../common/ConditionBox';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import { useContext } from 'react';
import styled from 'foundations-theming/utils';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const NewFilterPlaceholderContainer = styled.div.withConfig({
  displayName: "ViewerConditionPlaceholder__NewFilterPlaceholderContainer",
  componentId: "u73cot-0"
})([".condition-box{border:", " solid ", ";background-color:", ";}&.inner-placeholder{border-radius:0;.condition-box{padding-top:", ";padding-bottom:", ";}}"], props => props.useOnePanel ? '1px' : '2px', ({
  theme
}) => theme.color['fill-info-default'], ({
  useOnePanel,
  theme
}) => useOnePanel ? theme.color['fill-surface-recessed'] : theme.color['fill-info-subtle'], ({
  theme
}) => theme.space['100'], ({
  theme
}) => theme.space['100']);
const ViewerConditionPlaceholder = ({
  use = 'inner'
}) => {
  const {
    props: {
      uiMessages: {
        newFilterPlaceholderMessage
      },
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized: className, COMPLEX_TEMPLATE_EXPRESSION
    _jsx(NewFilterPlaceholderContainer, {
      className: `${use}-placeholder`,
      useOnePanel: !!useOnePanel,
      children: /*#__PURE__*/_jsx(ConditionBox, {
        size: "xs",
        children: /*#__PURE__*/_jsx(Flex, {
          justifyContent: "center",
          children: newFilterPlaceholderMessage || /*#__PURE__*/_jsx(FormattedMessage, {
            message: "newCustomerDataFilters.filtersViewer.newFilterPlaceholder"
          })
        })
      })
    })
  );
};
export default ViewerConditionPlaceholder;